import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#trainee_migration",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Enrollment Bill Claim")
  ])
], -1)
const _hoisted_3 = {
  id: "trainee_migration",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-4" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = { class: "col-md-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Claim No", -1)
const _hoisted_15 = { class: "col-md-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Bill", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { class: "col-md-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Bill Date", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "col-md-2 mt-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "p-4" }, " Instruction: Update Per bill (changing new Unit cost, Adjusted Amount) can be done only once.Requesting all Users to put required data where needed and then go for update. ", -1)
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-4" }, "Select Batches for certification Bill Claim", -1)
const _hoisted_26 = { class: "card mb-5 mb-xl-10" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "row mt-1 w-100 m-0" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" }, [
        /*#__PURE__*/_createElementVNode("input", {
          type: "text",
          class: "form-control ps-10 w-200px mt-1 form-control-sm",
          style: {"height":"1em"},
          placeholder: "Search"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-6 mt-1 text-end",
      "data-v-54b12dc8": ""
    }, [
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-warning fs-7 p-2 rounded-0",
        title: "Download PDF",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-pdf fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" invoice ")
      ])
    ])
  ])
], -1)
const _hoisted_28 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_29 = { class: "collapse show" }
const _hoisted_30 = { class: "card-body border-top p-6" }
const _hoisted_31 = {
  class: "table-responsive current",
  "data-kt-stepper-element": "content"
}
const _hoisted_32 = { class: "table table-bordered table-row-bordered table-row-gray-400 align-middle border border-gray-400 gs-2 gy-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder bg-light text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "w-25px text-center align-middle border border-gray-400" }, " TI "),
    /*#__PURE__*/_createElementVNode("th", { class: "w-25px text-center align-middle border border-gray-400" }, " Course "),
    /*#__PURE__*/_createElementVNode("th", { class: "w-25px text-center align-middle border border-gray-400" }, " BN "),
    /*#__PURE__*/_createElementVNode("th", { class: "w-25px text-center align-middle border border-gray-400" }, " Trainee Count "),
    /*#__PURE__*/_createElementVNode("th", { class: "w-25px text-center align-middle border border-gray-400" }, " Unit Cost "),
    /*#__PURE__*/_createElementVNode("th", { class: "w-25px text-center align-middle border border-gray-400" }, " Pay % "),
    /*#__PURE__*/_createElementVNode("th", { class: "w-25px text-center align-middle border border-gray-400" }, " Payment Amount "),
    /*#__PURE__*/_createElementVNode("th", { class: "w-25px text-center align-middle border border-gray-400" }, " Bill Amount "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center align-middle border border-gray-400" }, " New Unit Cost "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center align-middle border border-gray-400" }, " New Payment Amount "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center align-middle border border-gray-400" }, " New Bill Amount "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center align-middle border border-gray-400" }, " Adj. Amount ")
  ])
], -1)
const _hoisted_34 = ["data-kt-indicator"]
const _hoisted_35 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_36 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_37 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[8] || (_cache[8] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      name: "tranche_id",
                      placeholder: "Select Tranche",
                      modelValue: _ctx.batch.tranche_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches_info, (tranche) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: tranche.id,
                            label: tranche.label,
                            value: tranche.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tranche.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Partner",
                      modelValue: _ctx.batch.entity_id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getAllBillNo()))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (data) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: data.id,
                            label: data.entity_short_name,
                            value: data.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(data.entity_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      name: "name",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.claim_no) = $event)),
                      class: "form-control",
                      disabled: ""
                    }, null, 512), [
                      [_vModelText, _ctx.batch.claim_no]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _hoisted_17,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Bill",
                      modelValue: _ctx.batch.bill_no,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.batch.bill_no) = $event)),
                      filterable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allBillNo, (bl) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: bl.bill_sequence_no,
                            label: bl.bill_no,
                            value: bl.bill_sequence_no
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(bl.bill_no), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _hoisted_20,
                    _createVNode(_component_el_form_item, {
                      prop: "date",
                      class: "mb-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.batch.bill_date,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.batch.bill_date) = $event)),
                          "value-format": "YYYY-MM-DD",
                          format: "DD-MM-YYYY",
                          type: "date",
                          style: {"width":"100%"},
                          name: "disbursement_date"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("button", {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getAdjustmentBill())),
                      type: "button",
                      class: "btn btn-success btn-sm mt-4"
                    }, [
                      _createTextVNode(" Search "),
                      _hoisted_22
                    ])
                  ])
                ])
              ]),
              _hoisted_23,
              (_ctx.showCourseNotice == true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("table", _hoisted_32, [
                                _hoisted_33,
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billList, (info, index) => {
                                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                      _createElementVNode("td", null, _toDisplayString(info?.institute_info?.short_name), 1),
                                      _createElementVNode("td", null, _toDisplayString(info?.course_info?.course_name), 1),
                                      _createElementVNode("td", null, _toDisplayString(info?.batch_info?.batch_number), 1),
                                      _createElementVNode("td", null, _toDisplayString(info?.trainee_count), 1),
                                      _createElementVNode("td", null, _toDisplayString(info?.unit_cost), 1),
                                      _createElementVNode("td", null, _toDisplayString(info?.pay_percentage), 1),
                                      _createElementVNode("td", null, _toDisplayString(info?.net_payable), 1),
                                      _createElementVNode("td", null, _toDisplayString(info?.bill_amount), 1),
                                      _createElementVNode("td", null, _toDisplayString(info?.new_unit_cost), 1),
                                      _createElementVNode("td", null, _toDisplayString(info?.new_payment_amount), 1),
                                      _createElementVNode("td", null, _toDisplayString(info?.new_bill_amount), 1),
                                      _createElementVNode("td", null, _toDisplayString(info?.adjustment_amount), 1)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ]),
                            _createElementVNode("button", {
                              "data-kt-indicator": _ctx.loading ? 'on' : null,
                              class: "btn btn-lg btn-success",
                              type: "button",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.formSubmit()))
                            }, [
                              (!_ctx.loading)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                                    _createTextVNode(" Submit "),
                                    _createElementVNode("span", _hoisted_36, [
                                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.loading)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                                    _createTextVNode(" Please wait... "),
                                    _hoisted_38
                                  ]))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_34)
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}